import BonanzaListPanel from './bonanzaListPanel.container'

export default BonanzaListPanel